import ItemDetail from "./ItemDetail";

export default ItemDetail;
export { ItemDetail };
